import fileUtils from "fileUtils"
import React, { useEffect, useState } from "react"
import Select from "react-select"
import {
  addCaseSummary,
  getCaseSummaryData,
} from "../../core/services/api/patientDiagnosisService"
import Button from "../Button"
import InputField from "../InputField"
import "./HistoryView.scss"

export default function HistoryView({
  patientDetail,
  setResCaseSummaryData,
  setIsCaseSummaryData,
  recordDetails,
  appointmentDetails,
  isReadOnly,
  scrollToTop
}: any) {
  const centerId = appointmentDetails?.centerId
  const consultantId = appointmentDetails?.consultantId
  const appointmentId = appointmentDetails?.id
  const appointmentType = appointmentDetails?.appointmentType
  const recordId = recordDetails?.id
  const patientId = appointmentDetails?.patientId

  interface CaseSummaryDataType {
    [key: string]: string
  }
  const caseSummaryOptions = {
    duration: ["Days", "Weeks", "Months", "Year"],
    ecog: [
      "0 - Fully active, able to carry on all pre-disease performance without restriction",
      "1 - Restricted in physically strenuous activity but ambulatory and able to carry out work of a light or sedentary nature, e.g., light house work, office work",
      "2 - Ambulatory and capable of all selfcare but unable to carry out any work activities; up and about more than 50% of waking hours",
      "3 - Capable of only limited selfcare; confined to bed or chair more than 50% of waking hours",
      "4 - Completely disabled; cannot carry on any selfcare; totally confined to bed or chair",
      "5 - Dead",
    ],
    menstrual: ["Pre-menopause", "Post-menopause", "Peri-menopause", "N/A"],
    tobbaco: ["Yes", "No", "Not Known"],
    smoking: ["Smoker", "Non Smoker", "Not Known"],
    alcohol: ["Yes", "No", "Not Known"],
    family: ["Yes", "No", "Not Known"],
    familyDetail: [
      "Parents",
      "Sibling",
      "Children",
      "GrandChild",
      "Uncle",
      "Aunt",
      "Nephew",
      "Niece",
      "Cousin",
      "Grand Parent",
      "Great Grand parents",
    ],
    socioEconomic: ["Low", "Med", "High"],
    religion: ["Christian", "Hindu", "Muslim", "Sikh", "Others"],
    patientSurvival: ["Yes", "No", "Not Known"],
    martialtatus: ["Single", "Married", "Widowed", "Divorced"],
    allergies: ["Yes", "No", "Not Known"],
    cancer: ["Yes", "No", "Not Known"],
    surgery: ["Yes", "No", "Not Known"],
    cancerType: [
      "Breast",
      "Ovary",
      "Stomach",
      "Colon",
      "Prostate",
      "Pancrease",
      "Uterine",
      "Others",
    ],
    radiation: ["Yes", "No", "Not Known"],

    occupation: ["Not Working", "Retired", "Service", "Business"],
    healthInsunrance: ["Yes", "No", "Not Known"],
    tpa: [
      "United Health Care Parekh InsuranceTPA Private Limited",
      "Medi Assist Insurance TPA Private Limited",
      "MD India Health Insurance TPA Private Limited",
      "Paramount Health Services & Insurance TPA Private Limited",
      "Heritage Health Insurance TPA Private Limited",
      "Family Health Plan Insurance TPA Limited",
      "Raksha Health Insurance TPA Private Limited",
      "Vidal Health Insurance TPA Private Limited",
      "Anyuta Insuance TPA In Health Care Private Limited",
      "East West Assist Insurance TPA Private Limited",
      "Medsave Health Insurance TPA Limited",
      "Genins India Insurance TPA Limited",
      "Alankit Insurance TPA Limited",
      "Health India Insurance TPA Services Private Limited",
      "Good Health Insurance TPA Limited",
      "Vipul Medcorp Insurance TPA Private Limited",
      "Park Mediclaim Insurance TPA Private Limited",
      "Safeway Insurance TPA Private Limited",
      "Anmol Medicare Insurance TPA Limited",
      "Grand Insurance TPA Private Limited",
      "Rothshield Insurance TPA Limited",
      "Ericson Insurance TPA Private Limited",
      "Health Insurance TPA of India Limited",
      "Vision Digital Insurance TPA Private Limited",
      "Happy Insurance TPA Services Pvt. Ltd",
    ],
    cghs: ["Yes", "No", "Not Known"],
    ethnicity: [
      "Asian",
      "African",
      "Caucasian",
      "Hispanic",
      "American",
      "Pacific Islander",
      "Mixed race",
    ],
    language: [
      "English",
      "Hindi",
      "Marathi",
      "Gujarati",
      "Bangla",
      "Dogri",
      "Konkani",
      "Maithili",
      "Nepali",
      "Oriya",
      "Punjabi",
      "Sanskrit",
      "Sindhi",
      "Urdu",
    ],
    educationLevel: [
      "Uneducated",
      "Primary",
      "Secondary",
      "Metric",
      "12th",
      "Bachelors",
      "Masters",
      "PhD",
    ],
    vaccination: ["Yes", "No", "Not known"],
    vaccineOptions: ["Yes", "No"],
  }
  const familyHistory = {
    familyHistory: "",
    familyHistoryDetail: "",
    relationshipType: "",
    cancerType: "",
    cancerTypeOthers: "",
  }
  const [familyHistories, setFamilyHistories] = useState([familyHistory])
  const symptomsOption = [
    "Headache",
    "Vomiting",
    "Convulsion",
    "Vertigo",
    "Drowsiness",
    "Imbalance",
    "Visual disturbances",
    "ulceration on tongue",
    "Swelling on tongue",
    "Ulceration in oral cavity",
    "Swelling in oral cavity",
    "Bleeding from oral cavity",
    "Ulceration on lips",
    "Swelling of lips",
    "Bleeding from lips",
    "Fever",
    "Night sweat",
    "Weight loss",
    "Significant weight loss",
    "Fatigue",
    "Diarrhoea",
    "Abdominal pain",
    "Breathlessness at rest",
    "Breathlessness on exertion",
    "Chest pain",
    "Haemoptysis",
    "Hematemesis",
    "PR Bleeding",
    "Blackening of stools",
    "Distension of abdomen",
    "Bloating",
    "Nausea",
    "Perianal itching",
    "Perianal mass",
    "Perianal ulceration",
    "PV bleeding",
    "PV white",
    "discharge",
    "PV red discharge",
    "PV ulceration",
    "Urinary increased frequency of urination",
    "Difficulty in urination",
    "Haematuria",
    "Penile swelling",
    "Penile ulceration",
    "Abdominal lump",
    "Pedal oedema",
    "Bone pain",
    "Backache",
    "Anemia",
    "Leucocytosis",
    "Leucopenia",
    "Thrombocytopenia",
    "Thrombocytosis",
    "Jaundice",
    "Nasal discharge",
    "Epistaxis",
    "Nasal polyp",
    "Ear discharge",
    "Deafness",
    "Tinnitus",
    "Swelling in neck",
    "Discharge from eyes",
    "Redness of eyes",
    "Swelling of eyes",
    "Itching in eyes",
    "Decreased vision",
    "Blindness",
    "Swelling in axilla",
    "Swelling in inguinal region",
    "Testicular swelling",
    "Breast lump",
    "Nipple discharge",
    "Breast Ulceration",
    "Breast fungating mass",
    "Breast swelling",
  ]
  const InitialExaminationOption = {
    pallor: ["Yes", "No"],
    pallor2: ["Mild", "Moderate", "Severe"],
    icterus: ["Present", "Absent"],
    icterus2: [
      "Face & Neck, Bil < 5mgdl",
      "Chest & back, Bil 5-12 mg/dl",
      "Abdomen to knees, Bil 8-16 mg/dl",
      "Arms & legs below knees, Bil 10-18mg/dl",
      "Hands & feet, Bil >15mg/dl",
    ],
    cynosis: ["Absent", "Present"],
    cynosis2: ["Central", "Peripheral"],
    clubbing2: ["Absent", "Present"],
    clubbing: [
      "  0 (Absent)",
      "1 (Softening of nail bed)",
      "2 (Loss of hyponychial angle)",
      "3 (Convexity of nail)",
      "4 (Fingertips develop clubbed appearance, parrot beak)",
      "5 (Nail & skin develop glossy change with striation on nails, Osteoarthropathy)",
    ],
    lymphNodes: ["Non-palpable", "Palpable Unilateral", "Palpable Bilateral"],
    lymphNodes2: ["Cervical", "Supraclavicular", "Axillary", "Inguinal"],
    oedema: ["Absent", "Unilateral", "Bilateral"],
    oedema2: ["Pitting", "Non-pitting"],
    jvp: ["Normal", "High", "Low"],
    nutritionalState: ["Normal", "Average"],
    gait: ["Normal", "Abnormal"],
    cvs: ["NAD", "Significant"],
    heartSound: ["Normal", "Abnormal"],
    rs: ["NAD", "Significant"],
    airEntry: ["AEBE", "AE decreased"],
    abnormalSound: ["Rhonchi", "Crepitation’s", "Stridor", "Others"],
    pa: ["NAD", "Significant"],
    glSound: ["Yes", "No"],
    ascites: ["Yes", "No"],
    lump: ["Yes", "No"],
    tenderness: ["Yes", "No"],
    ent: ["NAD", "Significant"],
    nose: ["Normal", "Abnormal"],
    oralCavity: ["Normal", "Abnormal"],
    ear: ["Normal", "Abnormal"],
    cns: ["NAD", "Significant"],
    mentalStatus: ["Oriented", "Disoriented", "Unconscious"],
    motorSystem: ["Weakness Yes", "Weakness No"],
    sensoryMotor: ["Tingling & Numbness", "Pain"],
  }
  const [formCaseSummaryErrors, setFormCaseSummaryErrors] =
    useState<CaseSummaryDataType>({})
  // add new comborbidities
  const comorbidity = {
    comorbidities: "",
    number: "",
    duration: "",
    remarks: "",
  }
  const drugHistoryObj = {
    drugHistory: "",
    drugAllergies: "",
    allergies: [""]
  }
  const [caseSummaryData, setCaseSummaryData] = useState<any>({})
  const [drugs, setDrugs] = useState<any>([drugHistoryObj])
  let [comorbidities, setComorbidities] = useState([comorbidity])
  const [comorbidityValue, setcomorbidityValue] = useState("")
  const [isLoading, setIsLoading] = useState<boolean>(false)

  function onValueChange(source: any, value: any, index: any) {
    const values: any = [...comorbidities]
    if (!values[index]) {
      values[index] = {}
    }
    if (value === "NIL") {
      values[index] = {
        comorbidities: value,
        number: "",
        duration: "",
        remarks: "",
      }
    } else {
      values[index][source] = value
    }
    setComorbidities([...values])
  }

  const validateCaseSummary = (values: any) => {
    const errors: any = {}
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i
    // drpodown validation
    if (
      patientDetail?.gender?.toLowerCase() === "female" &&
      !values?.menstrualHistory
    ) {
      errors.menstrualHistory = "Menstrual History is required"
    }
    if (values.cancerHistory2 === "") {
      errors.cancerHistory2 = "Cancer History is required!"
    }
    const temp: any = [...drugs]?.map((d: any) => {
      if (d?.drugAllergies === "Yes" && ((Array.isArray(d?.allergies) && d?.allergies?.length > 0) ? !d?.allergies[0] : !d?.allergies)) {
        return { ...d, error: "Enter Allergies" }
      } else {
        const temp = { ...d }
        delete temp["error"]
        return { ...temp }
      }
    })
    const isDrugAllergyError = temp?.some((t: any) => Object.keys(t)?.includes("error"))
    if (isDrugAllergyError) {
      errors["allergies"] = "Yes"
    }
    setDrugs(temp)
    console.log("ERRORS---->", errors)
    return errors
  }

  const [isCaseSummarySubmit, setIsCaseSummarySubmit] = useState(false)

  const comborditiesOption = [
    "NIL",
    "DM",
    "HTN",
    "IHD",
    "BA",
    "OPD",
    "DCM",
    "Hypothroid",
    "Hyperthyroid",
    "RVD",
    "HBsAg",
    "HCV",
    "Others",
  ]
  const comborditiesOptions = comborditiesOption.map((ele: any) => {
    return { label: ele, value: ele }
  })

  const cancerAllergyOption = caseSummaryOptions.cancer.map((ele: any) => {
    return { label: ele, value: ele }
  })

  const menstrual = caseSummaryOptions?.menstrual.map((ele: any) => {
    return { label: ele, value: ele }
  })

  const handleCaseSummarySubmit = (e: any) => {
    e.preventDefault()
    setFormCaseSummaryErrors(validateCaseSummary(caseSummaryData))
    setIsCaseSummarySubmit(true)
  }

  useEffect(() => {
    if (scrollToTop) {
      scrollToTop()
    }
  }, [])

  useEffect(() => {
    // setIsLoading(true)
    getCaseSummaryData(patientId)
      .then((data: any) => {
        const res = data.data

        setCaseSummaryData({
          presentIllness: "",
          ecogStatus: "",
          kps: "",
          cancerHistory: res?.pastHistory[0]?.cancerHistory,
          cancerHistoryDetail: res?.pastHistory[0]?.cancerHistoryDetail,
          cancerHistoryNumber: "",
          cancerHistoryDuration: "",
          surgery: res?.pastHistory[2]?.surgery,
          surgeryDetail: res?.pastHistory[2]?.surgeryDetail,
          surgeryNumber: "",
          surgeryDuration: "",
          radiation: res?.pastHistory[1]?.radiation,
          radiationDetail: res?.pastHistory[1]?.radiationDetail,
          radiationNumber: "",
          radiationDuration: "",
          pastHistoryOthers: res?.pastHistory[3]?.others,
          relationshipType: "",
          cancerType: "",
          menstrualHistory: res?.menstrualHistory,
          tobbacco: res?.socioHistory?.tobbacco,
          tobbaccoNumber: res?.socioHistory?.tobbaccoDuration?.split("$")[0],
          tobbaccoDuration: res?.socioHistory?.tobbaccoDuration?.split("$")[1],
          smoking: res?.socioHistory?.smoking,
          smokingNumber: res?.socioHistory?.smokingDuration?.split("$")[0],
          smokingDuration: res?.socioHistory?.smokingDuration?.split("$")[1],
          alcohol: res?.socioHistory?.alcohol,
          alcoholNumber: res?.socioHistory?.alcoholDuration?.split("$")[0],
          alcoholDuration: res?.socioHistory?.alcoholDuration?.split("$")[1],
          familyHistory: "",
          familyhistoryDetails: "",
          socioEconomicStatus: "",
          occupation: "",
          healthInsunrance: "",
          tpa: "",
          cghs: "",
          cghs2: "",
          govtScheme: "",
          govtScheme2: "",
          ethnicity: "",
          language: "",
          martialStatus: "",
          educationLevel: "",
          income: "",
          patientBirthPlace: "",
          vaccinationHistory: res?.socioHistory?.vaccinationHistory,
          influenza: res?.socioHistory?.influenza,
          hepB: res?.socioHistory?.hepB,
          covid: res?.socioHistory?.covid,
          vaccinationOther: res?.socioHistory?.vaccinationOther,
          g: res?.obstetricsHistory?.g,
          a: res?.obstetricsHistory?.a,
          p: res?.obstetricsHistory?.p,
          l: res?.obstetricsHistory?.l,
        })
        if (res?.familyHistory) {
          setFamilyHistories(res?.familyHistory)
        }
        if (res?.comorbidities) {
          setComorbidities(res?.comorbidities)
        }
        if (res?.drugHistoryAndAllergies) {
          setDrugs(res?.drugHistoryAndAllergies)
        }
        setIsLoading(false)
      })
      .catch((err: any) => {
        console.log(err)
        setIsLoading(false)
      })
  }, [appointmentId, recordId])

  // function checkEmptyFields(obj: any) {
  //   for (const key in obj) {
  //     if (obj.hasOwnProperty(key) && (obj[key] !== "" && obj[key] !== undefined)) {
  //       return obj;
  //     }
  //   }

  //   // If all fields are empty strings or undefined, return an empty object
  //   return {};
  // }

  const buildCaseSummary = (summary: any) => {
    const {
      comorbidities,
      drugs,
      menstrualHistory,
      g,
      p,
      a,
      l,
      cancerHistory,
      cancerHistoryDetail,
      radiation,
      radiationDetail,
      surgery,
      surgeryDetail,
      pastHistoryOthers,
      familyHistories,
      tobbacco,
      tobbaccoNumber,
      tobbaccoDuration,
      smoking,
      smokingNumber,
      smokingDuration,
      alcohol,
      alcoholNumber,
      alcoholDuration,
      vaccinationHistory,
      influenza,
      hepB,
      covid,
      vaccinationOther,
    } = summary;

    const socioHistory = {
      tobbacco,
      tobbaccoDuration: tobbaccoNumber && tobbaccoDuration ? `${tobbaccoNumber}$${tobbaccoDuration}` : "",
      smoking,
      smokingDuration: smokingNumber && smokingDuration ? `${smokingNumber}$${smokingDuration}` : "",
      alcohol,
      alcoholDuration: alcoholNumber && alcoholDuration ? `${alcoholNumber}$${alcoholDuration}` : "",
      vaccinationHistory,
      influenza,
      hepB,
      covid,
      vaccinationOther,
    };

    return {
      comorbidities,
      drugHistoryAndAllergies: drugs,
      menstrualHistory,
      obstetricsHistory: { g, p, a, l },
      pastHistory: [
        { cancerHistory, cancerHistoryDetail },
        { radiation, radiationDetail },
        { surgery, surgeryDetail },
        { others: pastHistoryOthers },
      ],
      familyHistory: familyHistories,
      socioHistory,
    };
  };




  useEffect(() => {
    let temp = { ...caseSummaryData }
    let tempData = Object.keys(temp)?.length > 0 ? temp : null




    const newCaseSummary = buildCaseSummary({ ...tempData, comorbidities, familyHistories, drugs });

    console.log(newCaseSummary, "Before Building Case Summary");
    //comorbodities
    const comorbiditiesResult = fileUtils?.checkEmptyFieldsInArray(newCaseSummary?.comorbidities);
    //Past History
    const pastHistoryResult = fileUtils?.checkForListOfObject(newCaseSummary?.pastHistory);
    //Socio History
    const socioHistoryResult = fileUtils?.checkEmptyFields(newCaseSummary?.socioHistory);
    //family History
    const familyHistoryResult = fileUtils?.checkEmptyFieldsInArray(newCaseSummary?.familyHistory)
    //Drug History
    const drugHistoryResult = fileUtils?.checkEmptyFieldsInArrayWithArrays(newCaseSummary?.drugHistoryAndAllergies)

    //ObstetricHistory Result
    const obstetricsHistoryResult = fileUtils?.checkEmptyFields(newCaseSummary?.obstetricsHistory);


    // Update the comorbidities field in newCaseSummary with the comorbiditiesResult
    newCaseSummary.comorbidities = comorbiditiesResult;

    // Update the pastHistory field in newCaseSummary with the pastHistoryResult
    newCaseSummary.pastHistory = pastHistoryResult;

    // Update the socioHistory field in newCaseSummary with the socioHistoryResult
    newCaseSummary.socioHistory = socioHistoryResult;

    // Update the familyHistory field in newCaseSummary with the familyHistoryResult
    newCaseSummary.familyHistory = familyHistoryResult;

    // Update the drugHistoryAndAllergies field in newCaseSummary with the drugHistoryResult
    newCaseSummary.drugHistoryAndAllergies = drugHistoryResult;

    //Update
    newCaseSummary.obstetricsHistory = obstetricsHistoryResult;

    if (
      Object.keys(formCaseSummaryErrors).length === 0 &&
      isCaseSummarySubmit
    ) {
      // setIsLoading(true)

      //Previous Code
      // addCaseSummary(
      //   { ...tempData, comorbidities, familyHistories, drugs },
      //   {
      //     centerId,
      //     consultantId,
      //     patientId,
      //     appointmentId,
      //     recordId,
      //   }
      // )
      //   .then((data) => {
      //     setIsLoading(false)
      //     setResCaseSummaryData(data)
      //     setIsCaseSummaryData(true)
      //   })
      //   .catch((err) => {
      //     console.log(err)
      //     setIsLoading(false)
      //   })



      //Optimizing code
      if (scrollToTop) {
        scrollToTop()
      }
      addCaseSummary(
        newCaseSummary,
        {
          centerId,
          consultantId,
          patientId,
          appointmentId,
          recordId,
        }
      )
        .then((data) => {
          setIsLoading(false)
          setResCaseSummaryData(data)
          setIsCaseSummaryData(true)
        })
        .catch((err) => {
          console.log(err)
          setIsLoading(false)
        })
    } else if (Object.keys(formCaseSummaryErrors).length > 0) {
      scroll()
    }
  }, [formCaseSummaryErrors])

  function scroll() {
    let title = Object.keys(formCaseSummaryErrors)
    const temp = title.includes("menstrualHistory")
      ? "menstrualHistory"
      : title.includes("cancerHistory2")
        ? "cancerHistory2"
        : title.includes("allergies") ?
          "allergies"
          : ""
    const element = document.getElementById(temp)
    if (element) {
      element.scrollIntoView({ behavior: "smooth" })
    }
  }

  const daysofYear = {
    daysofweek: ["Day/Days", "Month/Months", "Year/Years", "Week/Weeks"],
  }
  function onValueChanges(source: any, value: any) {
    const values: any = { ...comorbidities }
    console.log({ ...values, ...{ monthView: value } })
  }
  const monthView: any = daysofYear?.daysofweek.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const drugAlergies: any = caseSummaryOptions?.allergies.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const drugAllergiessurgery: any = caseSummaryOptions?.surgery.map(
    (ele: any) => {
      return { label: ele, value: ele }
    }
  )
  const radiationOption = caseSummaryOptions.radiation.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const familyhistory = caseSummaryOptions.family.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const familydetails = caseSummaryOptions.familyDetail.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const cancertypes = caseSummaryOptions.cancerType.map((ele: any) => {
    return { label: ele, value: ele }
  })

  const socioHistorytobbaco = caseSummaryOptions.tobbaco.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const socioHistorysmoking = caseSummaryOptions.smoking.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const socioHistoryalcohol = caseSummaryOptions.alcohol.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const socioHistoryVacination = caseSummaryOptions.vaccination.map(
    (ele: any) => {
      return { label: ele, value: ele }
    }
  )
  const socioInfluenzea = caseSummaryOptions.vaccineOptions.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const sociohepb = caseSummaryOptions.vaccineOptions.map((ele: any) => {
    return { label: ele, value: ele }
  })
  const socioHistoryCovidVacination = caseSummaryOptions.vaccineOptions.map(
    (ele: any) => {
      return { label: ele, value: ele }
    }
  )


  console.log(isReadOnly, "isReadOnlyisReadOnly")
  return (
    <div className="case-summary">
      {
        isLoading && (
          <div
            style={{
              position: "absolute",
              top: "50%",
              right: "50%",
            }}
          >
            <div
              style={{ width: "3rem", height: "3rem" }}
              className="spinner-border text-primary"
            ></div>
          </div>
        )
      }
      <div className="heading mb-0 pb-1">Medical History</div>
      <form onSubmit={handleCaseSummarySubmit}>
        <div className="summary-content">
          <div className="com">
            <label htmlFor="">Comorbidities</label>
          </div>
          {comorbidities.map((e, index) => {
            return (
              <div className="comorbidities">
                <div className="col-md-2 col-lg-2">
                  <Select
                    onChange={(option: any) => {
                      const value: any = comborditiesOptions?.find(
                        (each: any) => each?.label === option?.value
                      )
                      onValueChange("comorbidities", value?.label, index)
                    }}
                    isDisabled={isReadOnly}
                    defaultInputValue={comorbidityValue}
                    value={comborditiesOptions.filter(
                      ({ value }) => value === e?.comorbidities
                    )}
                    isSearchable={true}
                    onInputChange={(e: any) => {
                      setcomorbidityValue(e)
                    }}
                    options={comborditiesOptions}
                  />

                </div>
                <div className="col-md-2 col-lg-2">
                  <InputField
                    handleChange={(e) => {
                      const value = e.target.value
                      let res = ""
                      value?.split("")?.forEach((ele) => {
                        let k = ele?.charCodeAt(0)
                        if (k >= 48 && k <= 57) {
                          res += ele
                        }
                      })
                      const values = [...comorbidities]
                      values[index].number = res
                      setComorbidities([...values])
                    }}
                    placeholder="Number"
                    value={comorbidities[index]?.number}
                    readOnly={
                      (comorbidities[index]?.comorbidities === "" ||
                        comorbidities[index]?.comorbidities === "NIL"
                        ? true
                        : false) || isReadOnly
                    }
                  ></InputField>
                </div>
                <div className="col-md-2 col-lg-2">
                  {/* <Dropdown
                    options={["Days", "Weeks", "Months", "Year"]}
                    selected={comorbidities[index].duration}
                    updateDropdown={(option: any) => {
                      const values = [...comorbidities]
                      values[index].duration = option
                      setComorbidities([...values])
                    }}
                    disable={
                      (comorbidities[index].comorbidities === "" ||
                        comorbidities[index].comorbidities === "NIL"
                        ? true
                        : false) || isReadOnly
                    }
                    placeholder={"Duration"}
                  ></Dropdown> */}
                  <Select
                    isDisabled={
                      (comorbidities[index]?.comorbidities === "" ||
                        comorbidities[index]?.comorbidities === "NIL"
                        ? true
                        : false) || isReadOnly
                    }
                    options={monthView}
                    onChange={(option: any) => {
                      const values = [...comorbidities]
                      values[index].duration = option?.label
                      setComorbidities(values)
                    }}
                    value={monthView.filter(
                      ({ label }: any) =>
                        label === comorbidities[index]?.duration
                    )}
                    defaultValue={monthView[index]?.label}

                  // disable={
                  //   (comorbidities[index].comorbidities === "" ||
                  //     comorbidities[index].comorbidities === "NIL"
                  //     ? true
                  //     : false) || isReadOnly
                  // }
                  />
                </div>
                <div className="col-md-2 col-lg-2">
                  <div className="d-flex  align-items-center">
                    <div>
                      <textarea
                        name=""
                        id=""
                        className={``}
                        onChange={(e) => {
                          const values = [...comorbidities]
                          values[index].remarks = e.target.value
                          setComorbidities([...values])
                        }}
                        value={comorbidities[index]?.remarks}
                        placeholder="Treatment/Remarks"
                        disabled={
                          comorbidities[index]?.comorbidities === "" ||
                            comorbidities[index]?.comorbidities === "NIL"
                            ? true
                            : false || isReadOnly
                        }
                      />
                    </div>
                    {!isReadOnly ? (
                      <div
                        className="delete-icon"
                        onClick={() => {
                          if (comorbidities.length > 1) {
                            const values = [...comorbidities]
                            values.splice(index, 1)
                            setComorbidities(values)
                          }
                        }}
                      >
                        <img src="../../assets/images/delete-icon.svg" alt="" />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            )
          })}

          {!isReadOnly ? (
            <div className="comorbidities add-new">
              <div
                className="add-new-button"
                onClick={() =>
                  setComorbidities([...comorbidities, comorbidity])
                }
              >
                Add New
              </div>
            </div>
          ) : (
            ""
          )}
          <div className="summary-row-small" id="allergies">
            <div className="col-md-3">
              <label htmlFor="">Drug History:</label>
            </div>
            <div className="col-md-3">
              <label htmlFor="">Drug Allergies:</label>
            </div>
            <div className="col-md-3">
              <label htmlFor="">*Enter Allergies:</label>
            </div>
          </div>
          {
            drugs?.map((each: any, index: any) => {
              return (
                <div className="summary-row-small mb-4">
                  <div className="col-md-3">
                    <InputField
                      handleChange={(e) => {
                        const values = [...drugs]
                        values[index]["drugHistory"] = e.target.value
                        setDrugs([...values])
                      }}
                      value={each?.drugHistory}
                      placeholder="Drug History"
                      readOnly={isReadOnly}
                    ></InputField>
                  </div>
                  <div className="col-md-3">
                    <Select
                      isDisabled={isReadOnly}
                      options={drugAlergies}
                      onChange={(option: any) => {
                        const values = [...drugs]
                        // values[index]["drugHistory"] = e.target.value
                        if (option !== "Yes") {
                          values[index]["drugAllergies"] = option?.value
                          values[index]["allergies"] = [""]
                          setDrugs([...values])
                        } else {
                          values[index]["drugAllergies"] = option?.value
                          setDrugs([...values])
                        }
                      }}
                      value={drugAlergies?.filter(({ label }: any) => label === drugs[index]["drugAllergies"])
                      }
                      defaultValue={each?.drugAllergies}

                    // disable={
                    //   (comorbidities[index].comorbidities === "" ||
                    //     comorbidities[index].comorbidities === "NIL"
                    //     ? true
                    //     : false) || isReadOnly
                    // }

                    />
                  </div>
                  <div className="col-md-3 allergies-input">
                    <InputField
                      handleChange={(e) => {
                        const values = [...drugs]
                        values[index]["allergies"] = [e.target.value]
                        setDrugs([...values])
                      }}
                      value={each?.allergies}
                      readOnly={(drugs[index]["drugAllergies"] === "Yes" ? false : true) || isReadOnly}
                      errorMsg={each?.error}
                    ></InputField>
                  </div>
                  <div className="col-md-2 col-lg-2 d-flex  align-items-center">
                    <div>
                      {
                        !isReadOnly ?
                          <div
                            className="delete-icon"
                            onClick={() => {
                              if (drugs?.length > 1) {
                                const values = [...drugs]
                                values.splice(index, 1)
                                setDrugs(values)
                              }
                            }}
                          >
                            <img src="../../assets/images/delete-icon.svg" alt="" />
                          </div> : ""
                      }
                    </div>

                  </div>
                </div>
              )
            })
          }
          {
            !isReadOnly ?
              <div className="comorbidities add-new">
                <div
                  className="add-new-button"
                  onClick={() => {
                    const values = [...drugs]
                    values.push(drugHistoryObj)
                    setDrugs(values)
                  }}
                >
                  Add New
                </div>
              </div> : ""
          }
          {
            patientDetail?.gender?.toLowerCase() === "female" && (
              <>
                <div className="summary-row">
                  <div className="col-md-3" id="menstrualHistory">
                    <label htmlFor="">{patientDetail?.gender?.toLowerCase() === "female" && "*"}Menstrual History:</label>
                    <Select
                      options={menstrual}
                      onChange={(option: any) => {
                        setCaseSummaryData({
                          ...caseSummaryData,
                          menstrualHistory: option?.value,
                        })
                      }}
                      isDisabled={isReadOnly}
                      placeholder="Select Menstrual History"
                      value={menstrual.filter(
                        ({ label }: any) => label === caseSummaryData?.menstrualHistory
                      )}
                    />
                    {
                      formCaseSummaryErrors?.menstrualHistory && <span style={{ color: "red" }}>{formCaseSummaryErrors?.menstrualHistory}</span>
                    }
                  </div>
                </div>
                {console.log(caseSummaryData?.g, "uuuuuuuuuuuu")}
                <div className="summary-row">
                  <label htmlFor="">Obstetrics History:</label>
                </div>
                <div className="summary-row-small">
                  <div>
                    <label htmlFor="">G:</label>
                    <InputField
                      readOnly={isReadOnly}
                      handleChange={(e) =>
                        setCaseSummaryData({
                          ...caseSummaryData,
                          g: e.target.value,
                        })
                      }
                      value={caseSummaryData?.g}
                    ></InputField>
                  </div>
                  <div>
                    <label htmlFor="">P:</label>
                    <InputField
                      readOnly={isReadOnly}
                      handleChange={(e) =>
                        setCaseSummaryData({
                          ...caseSummaryData,
                          p: e.target.value,
                        })
                      }
                      value={caseSummaryData?.p}
                    ></InputField>
                  </div>
                  <div className="">
                    <label htmlFor="">A:</label>
                    <InputField
                      readOnly={isReadOnly}
                      handleChange={(e) =>
                        setCaseSummaryData({
                          ...caseSummaryData,
                          a: e.target.value,
                        })
                      }
                      value={caseSummaryData?.a}
                    ></InputField>
                  </div>
                  <div className="">
                    <label htmlFor="">L:</label>
                    <InputField
                      readOnly={isReadOnly}
                      handleChange={(e) =>
                        setCaseSummaryData({
                          ...caseSummaryData,
                          l: e.target.value,
                        })
                      }
                      value={caseSummaryData?.l}
                    ></InputField>
                  </div>
                </div>
              </>
            )
          }
          <hr />
          <div className="summary-row">
            <label htmlFor="">Past History:</label>
          </div>
          <div className="summary-row">
            <div className="col-md-5">
              <label htmlFor="">Cancer History:</label>
              {/* <Dropdown
                options={caseSummaryOptions.cancer}
                selected={caseSummaryData.cancerHistory}
                updateDropdown={(option: any) => {
                  if (option === "No" ||
                    option === "Not Known") {
                    setCaseSummaryData({
                      ...caseSummaryData,
                      cancerHistory: option,
                      cancerHistoryDetail: ""
                    })
                  } else {
                    setCaseSummaryData({
                      ...caseSummaryData,
                      cancerHistory: option,
                    })
                  }
                }}
                placeholder="Cancer History"
                disable={isReadOnly}
              ></Dropdown> */}
              <Select
                options={cancerAllergyOption}
                defaultValue={cancerAllergyOption}
                onChange={(option: any) => {
                  if (option !== "Yes") {
                    setCaseSummaryData({
                      ...caseSummaryData,
                      cancerHistory: option?.value,
                      cancerHistoryDetail: "",
                    })
                  } else {
                    setCaseSummaryData({
                      ...caseSummaryData,
                      cancerHistory: option?.value,
                    })
                  }
                }}
                isDisabled={isReadOnly}
                placeholder="Cancer History"
                value={cancerAllergyOption.filter(
                  ({ label }: any) => label === caseSummaryData?.cancerHistory
                )}
              />
            </div>

            <div className="col-md-5">
              <label htmlFor="cancerDetails">Details:</label>
              <textarea
                name=""
                id="cancerDetails"
                className={`textarea ${(caseSummaryData?.cancerHistory !== "Yes" ? true : false) ||
                  isReadOnly
                  ? "disable"
                  : ""
                  }`}
                onChange={(e) =>
                  setCaseSummaryData({
                    ...caseSummaryData,
                    cancerHistoryDetail: e.target.value,
                  })
                }
                value={caseSummaryData?.cancerHistoryDetail}
                placeholder="Details"
                // disabled={(caseSummaryData.cancerHistory === "No" || caseSummaryData.cancerHistory === "Not Known" ? true : false)}
                disabled={
                  (caseSummaryData?.cancerHistory === "Yes" ? false : true) ||
                  isReadOnly
                }
              />
            </div>
            {/* disabled={(caseSummaryData.cancerHistory === "No" || caseSummaryData.cancerHistory === "Not Known" ? false : true)} */}
          </div>
          <div className="summary-row">
            <div className="col-md-5">
              <label htmlFor="">Surgery:</label>
              {/* <Dropdown
                options={caseSummaryOptions.surgery}
                selected={caseSummaryData.surgery}
                updateDropdown={(option: any) => {
                  if (option === "No" ||
                    option === "Not Known") {
                    setCaseSummaryData({
                      ...caseSummaryData,
                      surgery: option,
                      surgeryDetail: ""
                    })
                  } else {
                    setCaseSummaryData({
                      ...caseSummaryData,
                      surgery: option,
                    })
                  }
                }}
                placeholder="Surgery"
                width="470px"
                disable={isReadOnly}
              ></Dropdown> */}
              <Select
                options={drugAllergiessurgery}
                defaultValue={drugAllergiessurgery}
                onChange={(option: any) => {
                  if (option !== "Yes") {
                    setCaseSummaryData({
                      ...caseSummaryData,
                      surgery: option?.value,
                      surgeryDetail: "",
                    })
                  } else {
                    setCaseSummaryData({
                      ...caseSummaryData,
                      surgery: option?.value,
                    })
                  }
                }}
                isDisabled={isReadOnly}
                placeholder="Surgery"
                value={drugAllergiessurgery.filter(
                  ({ label }: any) => label === caseSummaryData?.surgery
                )}

              // disable={
              //   (comorbidities[index].comorbidities === "" ||
              //     comorbidities[index].comorbidities === "NIL"
              //     ? true
              //     : false) || isReadOnly
              // }
              />
            </div>

            <div className="col-md-5">
              <label htmlFor="surgeryDetails">Details:</label>
              <textarea
                name=""
                id="surgeryDetails"
                className={`textarea ${(caseSummaryData?.surgery === "Yes" ? false : true) ||
                  isReadOnly
                  ? "disable"
                  : ""
                  }`}
                onChange={(e) =>
                  setCaseSummaryData({
                    ...caseSummaryData,
                    surgeryDetail: e.target.value,
                  })
                }
                value={caseSummaryData?.surgeryDetail}
                placeholder="Details"
                disabled={
                  (caseSummaryData?.surgery === "Yes" ? false : true) ||
                  isReadOnly
                }
              />
            </div>
          </div>
          <div className="summary-row">
            <div className="col-md-5">
              <label htmlFor="">Radiation:</label>
              {/* <Dropdown
                options={caseSummaryOptions.cancer}
                selected={caseSummaryData.radiation}
                updateDropdown={(option: any) => {
                  if (option === "No" ||
                    option === "Not Known") {
                    setCaseSummaryData({
                      ...caseSummaryData,
                      radiation: option,
                      radiationDetail: ""
                    })
                  } else {
                    setCaseSummaryData({
                      ...caseSummaryData,
                      radiation: option,
                    })
                  }
                }}
                placeholder="Radiation"
                width="470px"
                disable={isReadOnly}
              ></Dropdown> */}
              <Select
                options={radiationOption}
                defaultValue={radiationOption}
                onChange={(option: any) => {
                  if (option !== "Yes") {
                    setCaseSummaryData({
                      ...caseSummaryData,
                      radiation: option?.value,
                      radiationDetail: "",
                    })
                  } else {
                    setCaseSummaryData({
                      ...caseSummaryData,
                      radiation: option?.value,
                    })
                  }
                }}
                isDisabled={isReadOnly}
                placeholder="Radiation"
                value={radiationOption.filter(
                  ({ label }: any) => label === caseSummaryData?.radiation
                )}

              // disable={
              //   (comorbidities[index].comorbidities === "" ||
              //     comorbidities[index].comorbidities === "NIL"
              //     ? true
              //     : false) || isReadOnly
              // }
              />
            </div>

            <div className="col-md-5">
              <label htmlFor="radiationDetails">Details:</label>
              <textarea
                name=""
                id="radiationDetails"
                className={`textarea ${(caseSummaryData?.radiation === "Yes" ? false : true) ||
                  isReadOnly
                  ? "disable"
                  : ""
                  }`}
                onChange={(e) =>
                  setCaseSummaryData({
                    ...caseSummaryData,
                    radiationDetail: e.target.value,
                  })
                }
                value={caseSummaryData?.radiationDetail}
                placeholder="Details"
                disabled={
                  (caseSummaryData?.radiation === "Yes" ? false : true) ||
                  isReadOnly
                }
              />
            </div>
          </div>
          <div className="summary-row">
            <div className="col-md-5">
              <label htmlFor="">Others:</label>
              <InputField
                placeholder="Others"
                value={caseSummaryData?.pastHistoryOthers}
                handleChange={(e) =>
                  setCaseSummaryData({
                    ...caseSummaryData,
                    pastHistoryOthers: e.target.value,
                  })
                }
                readOnly={isReadOnly}
              ></InputField>
            </div>
          </div>
          <hr />
          <div className="summary-row">
            <label htmlFor="">Family History:</label>
          </div>
          <>
            <div className="family-history">
              <div className="summary-row-small align-center">
                <div className="col-md-2 col-lg-3">
                  <label htmlFor="">Family History:</label>
                </div>
                <div className="col-md-2 col-lg-3">
                  <label htmlFor="">Family History Details:</label>
                </div>
                <div className="col-md-3 col-lg-1.5">
                  <label htmlFor="">Relationship Type:</label>
                </div>
                <div className="col-md-2 col-lg-2">
                  <label htmlFor="">Cancer Type:</label>
                </div>
              </div>
            </div>
            {familyHistories?.map((eachFamilyHistory, index) => {
              return (
                <div className="family-history">
                  <div className="summary-row-small align-center">
                    <div className="col-md-2 col-lg-3">
                      {/* <Dropdown
                      options={caseSummaryOptions.family}
                      selected={eachFamilyHistory.familyHistory}
                      updateDropdown={(option: any) => {
                        if (option !== "Yes") {
                          const values = [...familyHistories]
                          values[index] = {
                            familyHistory: option,
                            familyHistoryDetail: "",
                            relationshipType: "",
                            cancerType: "",
                            cancerTypeOthers: ""
                          }
                          setFamilyHistories([...values])
                        } else {
                          const values = [...familyHistories]
                          values[index].familyHistory = option
                          setFamilyHistories([...values])
                        }
                      }}
                      placeholder="Select"
                      disable={isReadOnly}
                    ></Dropdown> */}
                      <Select
                        options={familyhistory}
                        defaultValue={familyhistory}
                        onChange={(option: any) => {
                          if (option !== "Yes") {
                            const values = [...familyHistories]
                            values[index] = {
                              familyHistory: option?.value,
                              familyHistoryDetail: "",
                              relationshipType: "",
                              cancerType: "",
                              cancerTypeOthers: "",
                            }
                            setFamilyHistories([...values])
                          } else {
                            const values = [...familyHistories]
                            values[index].familyHistory = option?.value
                            setFamilyHistories([...values])
                          }
                        }}
                        isDisabled={isReadOnly}
                        placeholder="Family History"
                        value={radiationOption.filter(
                          ({ label }: any) =>
                            label === eachFamilyHistory.familyHistory
                        )}
                      />
                    </div>
                    <div className="col-md-2 col-lg-3">
                      {/* <Dropdown
                      options={caseSummaryOptions.familyDetail}
                      selected={eachFamilyHistory.familyHistoryDetail}
                      updateDropdown={(option: any) => {
                        const values = [...familyHistories]
                        values[index].familyHistoryDetail = option
                        setFamilyHistories([...values])
                      }}
                      disable={
                        (familyHistories[index].familyHistory === "Yes"
                          ? false
                          : true) || isReadOnly
                      }
                      placeholder={"Select"}
                    ></Dropdown> */}
                      <Select
                        options={familydetails}
                        defaultValue={familydetails}
                        onChange={(option: any) => {
                          const values = [...familyHistories]
                          values[index].familyHistoryDetail = option?.value
                          const relationshiptypeDegree = option?.value === "Parents" ||
                            option?.value === "Sibling" ||
                            option?.value === "Children"
                            ? "1st Degree"
                            : option?.value ===
                              "GrandChild" ||
                              option?.value === "Uncle" ||
                              option?.value === "Aunt" ||
                              option?.value ===
                              "Nephew" || option?.value ===
                              "Grand Parent" ||
                              option?.value === "Niece"
                              ? "2nd Degree"
                              : option?.value ===
                                "Cousin" ||
                                option?.value ===
                                "Great Grand parents"
                                ? "3rd Degree"
                                : ""
                          //values[index].relationshipType=
                          values[index].relationshipType = relationshiptypeDegree
                          setFamilyHistories([...values])

                        }}
                        placeholder="Family History Details"
                        value={familydetails.filter(
                          ({ label }: any) =>
                            label === eachFamilyHistory.familyHistoryDetail
                        )}
                        isDisabled={
                          (familyHistories[index].familyHistory === "Yes"
                            ? false
                            : true) || isReadOnly
                        }
                      />
                    </div>

                    <div className="col-md-3 col-lg-1.5 mt-4">
                      <InputField
                        // handleChange={(e) => {
                        //   const values = [...familyHistories]
                        //   values[index].relationshipType = e.target.value

                        // setFamilyHistories([...values])
                        // }}
                        placeholder="Select"
                        value={
                          familyHistories[index].relationshipType
                        }
                        readOnly={true}
                      ></InputField>
                    </div>
                    <div className="col-md-2 col-lg-2">
                      {/* <Dropdown
                      options={caseSummaryOptions.cancerType}
                      selected={eachFamilyHistory.cancerType}
                      updateDropdown={(option: any) => {
                        const values = [...familyHistories]
                        values[index].cancerType = option
                        setFamilyHistories([...values])
                      }}
                      placeholder={"Cancer Type"}
                      width="470px"
                      disable={(eachFamilyHistory.familyHistory !== "Yes" ? true : false) || isReadOnly}
                    ></Dropdown> */}
                      <Select
                        options={cancertypes}
                        defaultValue={cancertypes}
                        onChange={(option: any) => {
                          const values = [...familyHistories]
                          values[index].cancerType = option?.value
                          setFamilyHistories([...values])
                        }}
                        placeholder="Cancer Type"
                        value={cancertypes.filter(
                          ({ label }: any) =>
                            label === eachFamilyHistory.cancerType
                        )}
                        isDisabled={
                          (eachFamilyHistory.familyHistory !== "Yes"
                            ? true
                            : false) || isReadOnly
                        }

                      // disable={
                      //   (comorbidities[index].comorbidities === "" ||
                      //     comorbidities[index].comorbidities === "NIL"
                      //     ? true
                      //     : false) || isReadOnly
                      // }
                      />
                    </div>
                    {!isReadOnly ? (
                      <div
                        className="delete-icon pt-3"
                        onClick={() => {
                          if (familyHistories.length > 1) {
                            const values = [...familyHistories]
                            values.splice(index, 1)
                            setFamilyHistories(values)
                          }
                        }}
                      >
                        <img
                          src="../../assets/images/delete-icon.svg"
                          alt="delete"
                        />
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  {eachFamilyHistory.cancerType === "Others" && (
                    <div className="summary-row-small align-center">
                      <div className="col-md-2 col-lg-3">
                        <label htmlFor="">Others</label>
                        <InputField
                          handleChange={(e) => {
                            const values = [...familyHistories]
                            values[index].cancerTypeOthers = e.target.value
                            setFamilyHistories([...values])
                          }}
                          value={eachFamilyHistory.cancerTypeOthers}
                          readOnly={isReadOnly}
                        ></InputField>
                      </div>
                    </div>
                  )}
                </div>
              )
            })}
          </>
          {!isReadOnly ? (
            <div className="comorbidities add-new">
              <div
                className="add-new-button"
                onClick={() =>
                  //console.log("family history")
                  setFamilyHistories([...familyHistories, familyHistory])
                }
              >
                Add New
              </div>
            </div>
          ) : (
            ""
          )}

          <hr />
          <div className="summary-row">
            <label htmlFor="">Socio History:</label>
          </div>
          <div className="summary-row-small">
            <div className="col-md-4">
              <label htmlFor="">Tobbaco:</label>
              {/* <Dropdown
                options={caseSummaryOptions.tobbaco}
                selected={caseSummaryData.tobbacco}
                updateDropdown={(option: any) => {
                  if (option === "No" ||
                    option === "Not Known") {
                    setCaseSummaryData({
                      ...caseSummaryData,
                      tobbacco: option,
                      tobbaccoNumber: "",
                      tobbaccoDuration: ""
                    })
                  } else {
                    setCaseSummaryData({
                      ...caseSummaryData,
                      tobbacco: option,
                    })
                  }
                }}
                placeholder="Tobbaco"
                disable={isReadOnly}
              ></Dropdown> */}
              <Select
                options={socioHistorytobbaco}
                defaultValue={socioHistorytobbaco}
                onChange={(option: any) => {
                  if (option?.value === "No" || option?.value === "Not Known") {
                    setCaseSummaryData({
                      ...caseSummaryData,
                      tobbacco: option?.value,
                      tobbaccoNumber: "",
                      tobbaccoDuration: "",
                    })
                  } else {
                    setCaseSummaryData({
                      ...caseSummaryData,
                      tobbacco: option?.value,
                    })
                  }
                }}
                placeholder="Tobbaco"
                value={socioHistorytobbaco.filter(
                  ({ label }: any) => label === caseSummaryData?.tobbacco
                )}
                isDisabled={
                  (caseSummaryData?.tobbaccoNumber !== "Yes" ? false : true) ||
                  isReadOnly
                }
              />
            </div>
            <div className="col-md-4">
              <label htmlFor="">Number:</label>
              <InputField
                placeholder="Number"
                handleChange={(e) => {
                  const value = e.target.value
                  let res = ""
                  value.split("").forEach((ele) => {
                    let k = ele.charCodeAt(0)
                    if (k >= 48 && k <= 57) {
                      res += ele
                    }
                  })
                  setCaseSummaryData({
                    ...caseSummaryData,
                    tobbaccoNumber: res,
                  })
                }}
                value={caseSummaryData?.tobbaccoNumber}
                readOnly={
                  (!caseSummaryData?.tobbacco ? true : caseSummaryData?.tobbacco === "No" || caseSummaryData?.tobbacco === "" || caseSummaryData?.tobbacco === "Not Known" ? true : false) ||
                  isReadOnly
                }
              ></InputField>
            </div>
            <div className="col-md-3">
              <label htmlFor="">Duration:</label>
              {/* <Dropdown
                options={["Days", "Weeks", "Months", "Years"]}
                selected={caseSummaryData.tobbaccoDuration}
                updateDropdown={(option: any) => {
                  setCaseSummaryData({
                    ...caseSummaryData,
                    tobbaccoDuration: option,
                  })
                }}
                placeholder="Duration"
                disable={(caseSummaryData.tobbacco !== "Yes" ? true : false) || isReadOnly}
              ></Dropdown> */}
              {/* <Select
                options={monthView}
                defaultValue={caseSummaryData.tobbaccoDuration}
                onChange={(option: any) => {
                  setCaseSummaryData({
                    ...caseSummaryData,
                    tobbaccoDuration: option,
                  })
                }}
                value={monthView.filter(({ label }: any) => label === daysofYear?.daysofweek)}

              /> */}
              <Select
                options={monthView}
                onChange={(option: any) => {
                  setCaseSummaryData({
                    ...caseSummaryData,
                    tobbaccoDuration: option?.value,
                  })
                }}
                value={monthView.filter(
                  ({ label }: any) => label === caseSummaryData?.tobbaccoDuration
                )}
                defaultValue={caseSummaryData?.tobbaccoDuration}
                isDisabled={(caseSummaryData?.tobbacco !== "Yes" ? true : false) || isReadOnly}
              />
            </div>
          </div>
          <div className="summary-row-small">
            <div className="col-md-4">
              <label htmlFor="">Smoking:</label>
              {/* <Dropdown
                options={caseSummaryOptions.smoking}
                selected={caseSummaryData.smoking}
                updateDropdown={(option: any) => {
                  if (option === "Non Smoker" ||
                    option === "Not Known") {
                    setCaseSummaryData({
                      ...caseSummaryData,
                      smoking: option,
                      smokingNumber: "",
                      smokingDuration: ""
                    })
                  } else {
                    setCaseSummaryData({
                      ...caseSummaryData,
                      smoking: option,
                    })
                  }
                }}
                placeholder="Smoking"
                disable={isReadOnly}
              ></Dropdown> */}
              <Select
                options={socioHistorysmoking}
                defaultValue={socioHistorysmoking}
                onChange={(option: any) => {
                  if (
                    option?.value === "Non Smoker" ||
                    option?.value === "Not Known"
                  ) {
                    setCaseSummaryData({
                      ...caseSummaryData,
                      smoking: option?.value,
                      smokingNumber: "",
                      smokingDuration: "",
                    })
                  } else {
                    setCaseSummaryData({
                      ...caseSummaryData,
                      smoking: option?.value,
                    })
                  }
                }}
                isDisabled={isReadOnly}
                placeholder="Smoking"
                value={socioHistorysmoking.filter(
                  ({ label }: any) => label === caseSummaryData?.smoking
                )}
              />
            </div>
            <div className="col-md-4">
              <label htmlFor="">Number:</label>
              <InputField
                placeholder="Number"
                handleChange={(e) => {
                  const value = e.target.value
                  let res = ""
                  value.split("").forEach((ele) => {
                    let k = ele.charCodeAt(0)
                    if (k >= 48 && k <= 57) {
                      res += ele
                    }
                  })
                  setCaseSummaryData({
                    ...caseSummaryData,
                    smokingNumber: res,
                  })
                }}
                value={caseSummaryData?.smokingNumber}
                readOnly={(caseSummaryData?.smoking !== "Smoker" ? true : false) || isReadOnly}
              ></InputField>
            </div>
            <div className="col-md-3">
              <label htmlFor="">Duration:</label>
              {/* <Dropdown
                options={["Days", "Weeks", "Months", "Years"]}
                selected={caseSummaryData.smokingDuration}
                updateDropdown={(option: any) => {
                  setCaseSummaryData({
                    ...caseSummaryData,
                    smokingDuration: option,
                  })
                }}
                placeholder="Duration"
                disable={(caseSummaryData.smoking !== "Smoker" ? true : false)}
              ></Dropdown> */}
              <Select
                options={monthView}
                onChange={(option: any) => {
                  setCaseSummaryData({
                    ...caseSummaryData,
                    smokingDuration: option?.value,
                  })
                }}
                value={monthView.filter(
                  ({ label }: any) => label === caseSummaryData?.smokingDuration
                )}
                defaultValue={caseSummaryData?.smokingDuration}
                // isDisabled={(caseSummaryData.smoking !== "Smoker"  ? true : false)}
                isDisabled={(caseSummaryData?.smoking !== "Smoker" ? true : false) || isReadOnly}
              />
            </div>
          </div>

          <div className="summary-row-small">
            <div className="col-md-4">
              <label htmlFor="">Alcohol:</label>
              <Select
                options={socioHistoryalcohol}
                defaultValue={socioHistoryalcohol}
                onChange={(option: any) => {
                  console.log(option, "history option")
                  if (option?.value === "Not Known" || option?.value === "No") {
                    setCaseSummaryData({
                      ...caseSummaryData,
                      alcohol: option?.value,
                      alcoholNumber: "",
                      alcoholDuration: "",
                    })
                  } else {
                    setCaseSummaryData({
                      ...caseSummaryData,
                      alcohol: option?.value,
                    })
                  }
                }}
                placeholder="Alcohol"
                value={socioHistoryalcohol.filter(
                  ({ label }: any) => label === caseSummaryData?.alcohol
                )}
                isDisabled={
                  (caseSummaryData?.alcoholNumber === "No" ||
                    caseSummaryData?.alcoholNumber === "Not Known"
                    ? true
                    : false) || isReadOnly
                }

              // disable={
              //   (comorbidities[index].comorbidities === "" ||
              //     comorbidities[index].comorbidities === "NIL"
              //     ? true
              //     : false) || isReadOnly
              // }
              />
            </div>
            <div className="col-md-4">
              <label htmlFor="">Number:</label>
              <InputField
                placeholder="Number"
                handleChange={(e) => {
                  const value = e.target.value
                  let res = ""
                  value.split("").forEach((ele) => {
                    let k = ele.charCodeAt(0)
                    if (k >= 48 && k <= 57) {
                      res += ele
                    }
                  })
                  setCaseSummaryData({
                    ...caseSummaryData,
                    alcoholNumber: res,
                  })
                }}
                value={caseSummaryData?.alcoholNumber}
                readOnly={
                  (caseSummaryData?.alcohol !== "Yes"
                    ? true
                    : false) || isReadOnly
                }
              />
            </div>
            <div className="col-md-3">
              <label htmlFor="">Duration:</label>
              <Select
                options={monthView}
                onChange={(option: any) => {
                  setCaseSummaryData({
                    ...caseSummaryData,
                    alcoholDuration: option?.value,
                  })
                }}
                value={monthView.filter(
                  ({ label }: any) => label === caseSummaryData?.alcoholDuration
                )}
                defaultValue={caseSummaryData?.alcoholDuration}
                isDisabled={
                  (caseSummaryData?.alcohol !== "Yes"
                    ? true
                    : false) || isReadOnly
                }
              />
            </div>
          </div>
          <div className="summary-row-small">
            <div className="vaccination col-md-4">
              <label htmlFor=""> Vaccination History:</label>
              {/* <Dropdown
                options={caseSummaryOptions.vaccination}
                selected={caseSummaryData.vaccinationHistory}
                updateDropdown={(option: any) => {
                  if (option !== "Yes") {
                    setCaseSummaryData({
                      ...caseSummaryData,
                      vaccinationHistory: option,
                      influenza: "",
                      hepB: "",
                      covid: "",
                      vaccinationOther: ""
                    })
                  } else {
                    setCaseSummaryData({
                      ...caseSummaryData,
                      vaccinationHistory: option,
                    })
                  }
                }}
                placeholder={"Vaccination"}
                width="245px"
                disable={isReadOnly}
              ></Dropdown> */}
              <Select
                options={socioHistoryVacination}
                defaultValue={socioHistoryVacination}
                onChange={(option: any) => {
                  if (option?.value !== "Yes") {
                    setCaseSummaryData({
                      ...caseSummaryData,
                      vaccinationHistory: option?.value,
                      influenza: "",
                      hepB: "",
                      covid: "",
                      vaccinationOther: "",
                    })
                  } else {
                    setCaseSummaryData({
                      ...caseSummaryData,
                      vaccinationHistory: option?.value,
                    })
                  }
                }}
                placeholder="Vacination History"
                value={socioHistoryVacination.filter(
                  ({ label }: any) =>
                    label === caseSummaryData?.vaccinationHistory
                )}
                isDisabled={isReadOnly}
              />
            </div>
            <div className="vaccination col-md-4">
              <label htmlFor="">Influenza:</label>
              {/* <Dropdown
                options={caseSummaryOptions.vaccineOptions}
                selected={caseSummaryData.influenza}
                updateDropdown={(option: any) => {
                  setCaseSummaryData({
                    ...caseSummaryData,
                    influenza: option,
                  })
                }}
                placeholder={"Influenza"}
                disable={
                  (caseSummaryData.vaccinationHistory === "Yes" ? false : true)
                }
              /> */}
              <Select
                options={socioInfluenzea}
                defaultValue={socioInfluenzea}
                onChange={(option: any) => {
                  setCaseSummaryData({
                    ...caseSummaryData,
                    influenza: option?.value,
                  })
                }}
                placeholder="Influenza"
                value={socioInfluenzea.filter(
                  ({ label }: any) => label === caseSummaryData?.influenza
                )}
                isDisabled={
                  (caseSummaryData?.vaccinationHistory === "Yes" ? false : true) || isReadOnly
                }
              />
            </div>
            <div className="col-md-3">
              <label htmlFor=""> Hep B:</label>
              {/* <Dropdown
                options={caseSummaryOptions.vaccineOptions}
                selected={caseSummaryData.hepB}
                updateDropdown={(option: any) => {
                  setCaseSummaryData({ ...caseSummaryData, hepB: option })
                }}
                placeholder={"Hep B"}
                width="470px"
                disable={
                  (caseSummaryData.vaccinationHistory === "Yes"
                    ? false
                    : true) || isReadOnly
                }
              /> */}
              <Select
                options={sociohepb}
                defaultValue={sociohepb}
                onChange={(option: any) => {
                  setCaseSummaryData({ ...caseSummaryData, hepB: option?.value })

                }}
                placeholder="Hep B"
                value={socioInfluenzea.filter(
                  ({ label }: any) => label === caseSummaryData?.hepB
                )}
                isDisabled={
                  (caseSummaryData?.vaccinationHistory === "Yes"
                    ? false
                    : true) || isReadOnly
                }
              />
            </div>
          </div>
          {/* <div className="summary-row-small">
              
              <div>
                <label htmlFor="">Preferred language:</label>
                <Dropdown
                  options={caseSummaryOptions.language}
                  selected={caseSummaryData.language}
                  updateDropdown={(option: any) => {
                    setCaseSummaryData({
                      ...caseSummaryData,
                      language: option,
                    })
                  }}
                  placeholder="Language"
                  width="470px"></Dropdown>
              </div>
            
              
            </div> */}
          <div className="summary-row">
            <div className="col-md-4">
              <label htmlFor="">Covid vaccination completed(2dose)</label>
              {/* <Dropdown
                options={caseSummaryOptions.vaccineOptions}
                selected={caseSummaryData.covid}
                updateDropdown={(option: any) => {
                  setCaseSummaryData({ ...caseSummaryData, covid: option })
                }}
                placeholder={"Covid vaccination completed(2 dose)"}
                disable={
                  (caseSummaryData.vaccinationHistory === "Yes" ? false : true) || isReadOnly
                }
                width="470px"
              ></Dropdown> */}
              <Select
                options={socioHistoryCovidVacination}
                defaultValue={socioHistoryCovidVacination}
                onChange={(option: any) => {
                  setCaseSummaryData({
                    ...caseSummaryData,
                    covid: option?.value,
                  })
                }}
                placeholder="Vacination History"
                value={socioHistoryCovidVacination.filter(
                  ({ label }: any) => label === caseSummaryData?.covid
                )}
                isDisabled={
                  (caseSummaryData?.vaccinationHistory === "Yes"
                    ? false
                    : true) || isReadOnly
                }
              />
            </div>
            <div className="col-md-4">
              <label htmlFor="">Other:</label>
              <InputField
                handleChange={(e) =>
                  setCaseSummaryData({
                    ...caseSummaryData,
                    vaccinationOther: e.target.value,
                  })
                }
                value={caseSummaryData?.vaccinationOther}
                placeholder="Enter Other Vaccine details"
                readOnly={
                  (caseSummaryData?.vaccinationHistory === "Yes"
                    ? false
                    : true) || isReadOnly
                }
              />
            </div>
          </div>
          <div className="vital-submit">
            {isReadOnly ? "" : <Button text="Save" type="submit" id="save"></Button>}
          </div>
        </div>
      </form >
    </div >
  )
}
